var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoStoresIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 65,
    viewBox: "0 0 61 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7822 23.0625L21.3717 6H7.9L2.26222 20.625C2.09833 21.145 2 21.6975 2 22.25C2 25.825 5.76944 28.75 10.4239 28.75C14.7178 28.75 18.2578 26.28 18.7822 23.0625ZM31.5 28.75C36.1544 28.75 39.9239 25.825 39.9239 22.25C39.9239 22.12 39.9239 21.99 39.9239 21.86L38.2522 6H24.7806L23.1089 21.86C23.1089 21.86 23.1089 22.12 23.1089 22.25C23.1089 25.825 26.8783 28.75 31.5328 28.75H31.5ZM47.8889 32.1625V45H15.1111V32.1625C13.6689 32.6825 12.0956 32.975 10.4239 32.975C9.80111 32.975 9.17833 32.91 8.55556 32.8125V53.45C8.55556 55.9525 10.6206 58 13.1444 58H49.8556C52.3794 58 54.4444 55.9525 54.4444 53.45V32.8125C53.8217 32.8775 53.1989 32.975 52.5761 32.975C50.9044 32.975 49.3311 32.6825 47.8889 32.13V32.1625ZM60.7378 20.625L55.1 6H41.6283L44.2178 23.03C44.7094 26.2475 48.2822 28.75 52.5761 28.75C57.2306 28.75 61 25.825 61 22.25C61 21.6975 60.9017 21.145 60.7378 20.625Z",
    fill: "#2E406F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 3L58 59",
    stroke: "#0F1E45",
    strokeWidth: 3.25,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2L58 63",
    stroke: "#2E406F",
    strokeWidth: 3.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoStoresIcon);
export default __webpack_public_path__ + "static/media/NoStoresIcon.7677a155970a7e8dab96c3e6a0c9f1f1.svg";
export { ForwardRef as ReactComponent };